import React, { ReactNode, useState, Fragment } from 'react';
import RichContentItem, { RichContent } from 'modules/shared/components/rich-content-list/components/rich-content-item';
import Button from 'atomic/button';
import Icon from 'atomic/icon';

import './rich-content-list.scss';

interface RichContentListProps {
    richContentData: RichContent[];
}

const RICH_CONTENT_ITEMS_LIMIT = 1;

const RichContentList: React.FC<RichContentListProps> = ({ richContentData }) => {
    const [itemsLimit, setItemsLimit] = useState(RICH_CONTENT_ITEMS_LIMIT);

    const renderShowMoreToggle = (): ReactNode => {
        if (richContentData.length <= RICH_CONTENT_ITEMS_LIMIT) {
            return null;
        }

        const isShowAllLinks = itemsLimit === richContentData.length;
        const toggledLinksLimit = isShowAllLinks ? RICH_CONTENT_ITEMS_LIMIT : richContentData.length;

        return (
            <div
                className="rich-content-list__show-more"
            >
                <Button color="transparent-secondary" size="lg" onClick={(): void => setItemsLimit(toggledLinksLimit)}
                    className="show-more-btn"
                >
                    <Icon name={isShowAllLinks ? 'minus' : 'plus'} color="secondary" size={18} />
                    {isShowAllLinks ? 'Zwiń opis' : 'Rozwiń opis'}
                </Button>
            </div>
        );
    };

    return (
        <div className="rich-content-list">
            {richContentData.map(({ title, html, alt, photoUrl }, idx) => (
                <Fragment key={title}>
                    <RichContentItem
                        title={title}
                        photoUrl={photoUrl}
                        alt={alt}
                        html={html}
                        hideItem={idx >= itemsLimit && idx !== 1}
                        showHalf={idx === 1 && idx >= itemsLimit}
                    />
                    { idx < richContentData.length - 1 && idx < itemsLimit && (
                        <div className="separator" />
                    )}
                </Fragment>
            ))}
            {renderShowMoreToggle()}
        </div>
    );
};

export default RichContentList;
